import type { TTagIconInitialProps } from './types'

export const TAG_ICON_INITIAL_PROPS: TTagIconInitialProps = {
  textAlign: 'left',
}
